import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@salesforce/design-system-react';

import { t } from 'lib/I18n';
import BadgeSharing from './BadgeSharing';

export default class RewardDetails extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    badgeName: PropTypes.string.isRequired,
    iconUrl: PropTypes.string.isRequired,
    assistiveText: PropTypes.object.isRequired,
    sharing: PropTypes.object,
    pointsBreakdown: PropTypes.object,
    next: PropTypes.object,
    survey: PropTypes.object,
    newCelebrationEnabled: PropTypes.bool,
    isStreaksEnabled: PropTypes.bool,
    isMyTrailhead: PropTypes.bool,
  }

  static defaultProps = {
    sharing: undefined,
    pointsBreakdown: undefined,
    next: undefined,
    survey: undefined
  }

  componentDidMount() {
    this.setLastPageCtaProp();

    if(this.props.isStreaksEnabled && window.emitter?.emit) {
      /**
       * Note: if you plan to force-open the modal on page load for localhost testing,
       * you must first wrap window.emitter.emit call below in a ~800 ms setTimeout()!
       * This ensures that the API call finishes and the event listener is created
       * in the th-streaks-manager before emit() is called.
       */
      window.emitter.emit("custom", {
        name: "award_earned",
        payload: {},
      });
    }
  }

  lastPageCtaConfig = () => {
    const {next} = this.props;

    if(next && next.type) {
      return {
        href: next.url,
        label: t(`views.client.check_challenge.complete.next_${next.type}`).replace(':', ''),
      }
    } else {
      return null;
    }
  }

  setLastPageCtaProp = () => {
    const lastPageCta = this.lastPageCtaConfig();
    const { modalRef } = this.props;

    if (modalRef && modalRef.current) {
      modalRef.current.lastPageCta = lastPageCta ? { ...lastPageCta } : null;
    }
  };

  headingClassname() {
    return this.props.newCelebrationEnabled ? "th-celebration-modal__heading" : "th-text th-text--large tds-text_neutraface";
  }

  renderHeading() {
    const {title} = this.props;

    return (
      <h2 className={this.headingClassname()}>
        {title}
      </h2>
    );
  }

  renderBadgeName() {
    const {badgeName} = this.props;

    return (
      <h3 className="th-text--bold th-text--default th-color--black slds-p-bottom_medium">
        {badgeName}
      </h3>
    );
  }

  renderSubtitle() {
    const {subtitle} = this.props;

    return (
      <h3 className="th-text th-text--small th-color--black">
        {subtitle}
      </h3>
    );
  }

  renderIcon() {
    const {
      title,
      iconUrl,
      assistiveText: {iconLabel}
    } = this.props;

    return (
      <div className="th-badge-reward">
        <img
          className="th-badge-reward__image"
          src={iconUrl}
          alt=""
        />
        <Icon
          containerClassName="th-badge-reward__state"
          assistiveText={{label: iconLabel}}
          category="action"
          name="approval"
          size="small"
        />
      </div>
    );
  }

  renderSharing() {
    const {sharing} = this.props;

    return sharing && sharing.public && (
      <div className="slds-text-align--center">
        <BadgeSharing sharing={sharing} />
      </div>
    );
  }

  surveyTitleClass() {
    return this.props.newCelebrationEnabled ? "slds-m-top--x-large th-text--small th-color--black slds-m-top--medium" : "th-text--bold th-text--small th-color--black slds-m-top--medium"
  }

  renderSurvey() {
    if (!this.props.survey) {
      return null;
    }

    const {
      survey: {title, url, link_text}
    } = this.props;

    return (
      <div>
        <h3 className={this.surveyTitleClass()}>
          {title}
        </h3>
        <h4 className="th-text th-text--small slds-m-top--medium">
          <a
            href={url}
            rel="noopener noreferrer"
            target="_blank"
            className={this.props.newCelebrationEnabled ? "slds-button slds-button_neutral tds-button_neutral" : null}>
            {link_text}
          </a>
        </h4>
      </div>
    );
  }

  render() {
    return (
      <div className="slds-text-align--center">
        {this.renderHeading()}
        {this.renderIcon()}
        {this.renderBadgeName()}
        {this.props.newCelebrationEnabled ? (
          <>
            {this.props.pointsBreakdown}
            {this.renderSubtitle()}
          </>
        ) : (
          <>
            {this.renderSubtitle()}
            {this.props.pointsBreakdown}
          </>
        )}
        {this.renderSharing()}
        {this.renderSurvey()}
      </div>
    );
  }
}
